import React  from 'react';
import '../myutils';
import PropTypes from 'prop-types';
import {
    BooleanField,
    BooleanInput,
    Datagrid,
    DisabledInput,
    Edit,
    EditButton,
    FormTab,
    List, Create,
    NumberField,
    ReferenceManyField,
    Responsive,
    SaveButton,
    Show,
    SimpleForm,
    SimpleList,
    Tab,
    TabbedForm,
    TabbedShowLayout,
    TextField,
    TextInput,
    Toolbar,
    translate,
    SelectInput,
    NumberInput
} from 'react-admin';
import SendButton from '../buttons/SendButton';
import UpdateEntries from '../buttons/UpdateEntries';
import TemplateActions from './templateActions';
import RecUploader from '../res/recUploader';
import ListUploader from '../res/listUploader';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import ActionNoteAdd from '@material-ui/icons/NoteAdd';
import ArrowBack from '@material-ui/icons/ArrowBack';
import { withStyles, Radio, Switch, Checkbox, Tooltip, IconButton } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import { push as pushAction } from 'react-router-redux';
import { connect } from 'react-redux';
import { configAPI } from '../config'
import {
    NodeActions,
} from 'ra-tree-ui-materialui';


class CustomNodeCheckBox extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            notclicked: true
        }
    }

    componentWillMount() {
        if (sessionStorage.selectedEntry===undefined) sessionStorage.setItem('selectedEntry','')
    }

    componentDidMount(){
        sessionStorage.selectedEntry = '';
        this.setState({notclicked:true})
    }

    componentWillReceiveProps(prevProps) {
        if (sessionStorage.selectedEntry.indexOf(this.props.record.rowid+',')>-1) this.setState({[this.props.record.id]:true})
        else this.setState({[this.props.record.id]:false})
    }

    handleChange = name => event => {

        const { record } = this.props;
        var selectedEntry;
        this.setState({ [name]: event.target.checked });
        if (sessionStorage.getItem("selectedEntry") === null) selectedEntry = ''
        else selectedEntry = sessionStorage.getItem('selectedEntry');

        if (event.target.checked) {
            selectedEntry = record.rowid + ',' + selectedEntry;
            sessionStorage.setItem('selectedEntry', selectedEntry);
        }
        else {
            selectedEntry = selectedEntry.replace(record.rowid + '-', '');
            sessionStorage.setItem('selectedEntry', selectedEntry);
        }
        this.setState({multi: selectedEntry.length > 1});
    };

    handleCheckChange = name => event => {
        this.setState({ notclicked: false });
        var selectedEntry;
        const { record } = this.props;
        this.setState({ [name]: event.target.checked });
        if (sessionStorage.getItem("selectedEntry") === null) selectedEntry = ''
        else selectedEntry = sessionStorage.getItem('selectedEntry');

        if (event.target.checked) {
            selectedEntry = record.rowid + '-' + selectedEntry;
            sessionStorage.setItem('selectedEntry', selectedEntry);
        }
        else {
            selectedEntry = selectedEntry.replace(record.rowid + '-', '');
            sessionStorage.setItem('selectedEntry', selectedEntry);
        }
        this.setState({multi: selectedEntry.length > 1});

    };

    render() {
        const { data } = this.props;

        return (
            <NodeActions 
            {...data} 
            onClick={this.props.refreshActions}
            >
                    <Checkbox
                        type='checkbox'
                        checked={sessionStorage.selectedEntry.includes(this.props.record.rowid+'-')&&this.props.checkall!==-1}//{(this.state[this.props.record.id])&&this.props.checkall!==-1}//||((this.props.checkall===true)&&this.state.notclicked) }
                        onChange={this.handleCheckChange(this.props.record.id)}                                
                        value={this.props.record.id}
                        onClick={(e)=>{e.stopPropagation()}}
                    />
            </NodeActions>
        );
    }
}


const toolbarStyles = {
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
};

SendButton.propTypes = {
    addLabel: PropTypes.bool,
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

const DefaultRadio = ({ source, record = {} }) => <Radio checked={record[source]} onClick={(e) => {
    e.stopPropagation();
    const request = new Request(configAPI.api.prod + 'UpdateTemplate?token=' + sessionStorage.B.encodeDecode() + '&templateId=' + record["id"] + "&customerDefault=1");
    fetch(request);
    window.location.reload();
}}></Radio>;

DefaultRadio.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

const BlockedBoolean = ({ source, record = {} }) => <Switch checked={record[source]} onChange={(e) => {
    e.stopPropagation();
    const request = new Request(configAPI.api.prod + 'UpdateTemplateEntry?token=' + sessionStorage.B.encodeDecode() + '&templateId=' + record["templateId"] + '&rowid=' +
        record["rowid"] + '&blocked=' + Number(!record[source]));
    fetch(request);
    window.location.reload();
}}></Switch>;

BlockedBoolean.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

class TemplateList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentWillMount() {
        if (this.props.history.location.search==='?new') this.props.push('/Templates/'+sessionStorage.NewCampaign)
    }

    componentDidMount() {
    }

    render() {
        const { translate, push, ...props } = this.props;

        return (
            <>
                <AppBar position="static" color="default" elevation={1}>
                    <Toolbar>
                        <Typography variant="title" color="inherit" style={{ width: '80%', float: "right" }}>
                            {translate('resources.templates.name')}
                        </Typography>
                    </Toolbar>
                </AppBar>

                <List
                    {...props}
                    actions={<TemplateActions />}
                    sort={{ field: 'published_at', order: 'DESC' }}
                >
                    <Responsive
                        small={
                            <SimpleList
                                primaryText={record => record.title}
                                secondaryText={record => `${record.views} views`}
                                tertiaryText={record =>
                                    new Date(record.published_at).toLocaleDateString()}
                            />
                        }
                        medium={
                            <Datagrid
                                rowClick={(eventtype, id, basePath, record) => {
                                    sessionStorage.setItem('templateId',id);
                                    push('/Templates/' + id);
                                }}>
                                <TextField source="index" label='resources.templates.index' />
                                <TextField source="templateId" label='resources.templates.templateId' />
                                <SendButton record={props} source="templateId" label='' />
                                <TextField source="description" label='resources.templates.description' />
                                <DefaultRadio source="customerDefault" label='resources.templates.customerDefault' push />
                                <NumberField source="entriesCount" label='resources.templates.entriesCount' />
                                <NumberField source="blockedEntriesCount" label='resources.templates.blockedEntriesCount' />
                            </Datagrid>
                        }
                    />
                </List>

            </>
        );
    }
}

export default connect(null, {
    push: pushAction,
})(translate(TemplateList));

const EntryToolbar = translate(({ record, translate }) => (
    <Toolbar >
        <Tooltip title={translate(`trans.newEntry`)}>
            <IconButton
                component={Link}
                to={{
                    pathname: '/GetTemplateEntries/create',
                    state: { record: { templateId: record.templateId } },
                }}>
                <ActionNoteAdd color="primary" />
            </IconButton>
        </Tooltip>
        <ListUploader msg={3} record={record} source={record.templateId} />
        <UpdateEntries action='delete' templateId={record.templateId}/>
        <UpdateEntries action='block' templateId={record.templateId}/>
        <UpdateEntries action='unblock' templateId={record.templateId}/>        
    </Toolbar>
));

const EditToolbar = withStyles(toolbarStyles)(props => (
    <Toolbar {...props}>
        <Button
            Button variant="contained"
            color="primary"
            component={Link}
            to={{
                pathname: '/Templates',
            }}
        >
            <ArrowBack />
        </Button>
        <SaveButton />
    </Toolbar>
));

const TemplateTitle = translate(({ record, translate }) => (
    <span>
        {record ? translate('post.edit.title', { title: record.title }) : ''}
    </span>
));

const TemplateCreateToolbar = props => (
    <Toolbar {...props}>
        <SaveButton
            label=""
            redirect={redirect}
            submitOnEnter={false}
            raised={false}
        />
        <Button
            Button variant="contained"
            color="primary"
            component={Link}
            to={{
                pathname: '/Templates/' + props.record.templateId + '/2',
            }}
        >
            <ArrowBack />
        </Button>
    </Toolbar>
);


export const EntryEdit = props => (
    <Edit {...props}>
        <SimpleForm
            toolbar={<TemplateCreateToolbar />}
            form={`post_edit_${props.id}`}
        >
            <DisabledInput source="templateId" label='resources.templates.templateId' />
            <TextInput source="phone" label='resources.templates.phone' />
            <TextInput source="name" label='resources.templates.entryname' defaultValue=''/>
            <TextInput source="moreinfo" label='resources.templates.moreinfo' defaultValue=''/>
            <BooleanInput source="blocked" label='resources.templates.blocked' />
        </SimpleForm>
    </Edit>
);

const redirect = (basePath, id, data) => `/Templates/${data.templateId}/2`;
const required = (message = 'Required') =>
    value => value ? undefined : message;

export const EntryCreate = props => (
    <Create {...props} >
        <SimpleForm
            toolbar={<TemplateCreateToolbar />}
            defaultValue={{ average_note: 0 }}
        >
            <DisabledInput source="templateId" label='resources.templates.templateId' />
            <TextInput source="phone" label='resources.templates.phone' validate={required()}/>
            <TextInput source="name" label='resources.templates.entryname' defaultValue=''/>
            <TextInput source="moreinfo" label='resources.templates.moreinfo' defaultValue=''/>
            <BooleanInput source="blocked" label='resources.templates.blocked' />
        </SimpleForm>
    </Create>
);

class EntryList extends React.Component {

    constructor(props) {
        super(props);
        this.refreshActions = this.refreshActions.bind(this)
    }

    componentWillMount() {
        this.setState({checked: false});
        if (sessionStorage.selectedEntry===undefined) sessionStorage.setItem('selectedEntry','')
    }

    refreshActions(e) {
        e.stopPropagation();
        var filter = sessionStorage.Filter;
        if (filter===undefined || filter ==='') filter='{"path":"ivr2:"}';
    }

    handleCheckChange = name => event => {
        this.setState({ [name]: event.target.checked });
        if (name === 'checkall') {
            if (!this.state.checkall) sessionStorage.setItem('selectedEntry', sessionStorage.allEntries);
            else sessionStorage.setItem('selectedEntry', '');
            this.setState({checkall: !this.state.checkall})
        }
    };


        
    render() {
        const { translate, push, ...props } = this.props;

    return (<Edit {...props}>
               <ReferenceManyField
                    reference="GetTemplateEntries"
                    target="templateId"
                    sort={{ field: 'created_at', order: 'DESC' }}
                >
                    <Datagrid expand={<EntryEdit {...props}/>} >
                    <CustomNodeCheckBox push={push} {...props} label={
                                <NodeActions push={push}>
                                    <Checkbox
                                        type='checkbox'
                                        onChange={this.handleCheckChange('checkall')}
                                        checked={ this.state.checkall}
                                    />
                                </NodeActions>}
                                record={props} refreshActions={this.refreshActions} checkall={this.state.checkall} />
                        <TextField source="phone" label='resources.templates.phone' />
                        <TextField source="name" label='resources.templates.entryname' />
                        <TextField source="moreinfo" label='resources.templates.moreinfo' />
                        <BooleanField source="blocked" label='resources.templates.blocked' />
                        {/* <BlockedBoolean source="blocked" label='resources.templates.blocked' push /> */}
                        <EditButton></EditButton>
                    </Datagrid>
                </ReferenceManyField>
            </Edit>)
    }
} 

EntryList.propTypes = {
    push: PropTypes.func,
};

connect(null, {
    push: pushAction,
})(translate(EntryList));



export const TemplateEdit = props => (
    <Edit title={<TemplateTitle />} {...props}>
        <TabbedForm defaultValue={{ average_note: 0 }} toolbar={<EditToolbar {...props} />} {...props}>
            <FormTab label='resources.templates.props' >
                <DisabledInput source="templateId" label='resources.templates.templateId' />
                <TextInput source="callerId" label='resources.templates.callerId' />
                <BooleanInput source="customerDefault" label='resources.templates.customerDefault' />
                <BooleanInput source="playPrivateMsg" label='resources.templates.playPrivateMsg' />
                <BooleanInput source="vmDetect" label='resources.templates.vmDetect' />
                <TextInput source="description" label='resources.templates.description' />
                <NumberInput source="maxActiveChannels" label='resources.templates.maxActiveChannels' />
                <NumberInput source="maxBridgedChannels" label='resources.templates.maxBridgedChannels' />
                <NumberInput source="maxDialAttempts" label='resources.templates.maxDialAttempts' />
                <SelectInput label="resources.templates.redialPolicy" source="redialPolicy" choices={[
                    { id: 'NONE', name: `resources.templates.none` },
                    { id: 'CONGESTIONS', name: (`resources.templates.congestions`) },
                    { id: 'FAILED', name: (`resources.templates.failed`) }
                ]} />
                <SelectInput label="resources.templates.incomingPolicy" source="incomingPolicy" choices={[
                    { id: 'OPEN', name: (`resources.templates.open`) },
                    { id: 'BLACKLIST', name: (`resources.templates.blacklist`) },
                    { id: 'WHITELIST', name: (`resources.templates.whitelist`) },
                    { id: 'BLOCKED', name: (`resources.templates.blocked`) },
                ]} />
                <NumberInput source="redialWait" label='resources.templates.redialWait' />
                {/* <TextInput source="removeRequest" label='resources.templates.removeRequest'/> */}
                <SelectInput label="resources.templates.removeRequest" source="removeRequest" choices={[
                    // { id: 'NONE', name: (`resources.templates.no_remove`) },
                    { id: 'SILENT', name: (`resources.templates.silent`) },
                    { id: 'WITH_MESSAGE', name: (`resources.templates.with_message`) },
                ]} />
            </FormTab>
            <FormTab label="resources.templates.recordingUploads">
                <div style={{height:'50px'}}/>
                <RecUploader msg={1} record={props} source="templateId" />
                <div style={{height:'50px'}}/>
                <RecUploader msg={2} record={props} source="templateId" />
            </FormTab>
            <FormTab label="resources.templates.phoneNumbers" >
                <EntryToolbar {...props} />
                <EntryList push={props.push} {...props}/>
            </FormTab>
        </TabbedForm>
    </Edit>)




export const TemplateShow = props => (
    <Show title={<TemplateTitle />} {...props}>
        <TabbedShowLayout>
            <Tab label="resources.templates.props">
                <TextField source="templateId" label="resources.templates.templateId" />
                <TextField source="description" label="resources.templates.description" />
                <TextField source="entriesCount" label="resources.templates.entriesCount" />
                <TextField source="maxActiveChannels" label="resources.templates.maxActiveChannels" />
                <TextField source="maxBridgedChannels" label="resources.templates.maxBridgedChannels" />
                <TextField source="maxDialAttempts" label="resources.templates.maxDialAttempts" />
                <TextField source="redialPolicy" label="resources.templates.redialPolicy" />
                <TextField source="redialWait" label="resources.templates.redialWait" />
                <TextField source="removeRequest" label="resources.templates.removeRequest" />
            </Tab>
            <Tab label="resources.templates.phoneNumbers">
                <ReferenceManyField
                    reference="GetTemplateEntries"
                    target="templateId"
                    sort={{ field: 'created_at', order: 'DESC' }}
                >
                    <Datagrid selectable="false">
                        <TextField source="phone" label='resources.templates.phone' />
                        <TextField source="name" label='resources.templates.entryname' />
                        <TextField source="moreinfo" label='resources.templates.moreinfo' />
                        <BooleanField source="blocked" label='resources.templates.blocked' />
                    </Datagrid>
                </ReferenceManyField>
            </Tab>
        </TabbedShowLayout>
    </Show>
);